import { createSelector } from 'reselect'
import { pendingSelector } from 'api/selectors'
import * as auth from '../auth'

export const vehiclesSelector = createSelector(auth.selectors.userSelector, user => (user ? user.vehicles : []))

export const createVehiclePendingSelector = createSelector(pendingSelector, pending => pending.createVehicle)
